import React from 'react';

export default function Doctor() {
  return (
    <section className="doctor" id="doctor" style={{ paddingTop: 72 }}>
      <div className="container">
        <div className="doctor-grid">
          <div className="doctor-visual fade-up">
            <div className="doctor-photo-frame">
              <div className="doctor-placeholder">🧑‍⚕️</div>
              <div className="doctor-tag">
                <h3>Dr. Shruthi Shetty</h3>
                <p>BAMS, MD</p>
              </div>
            </div>
            <div className="doctor-accent-box">
              <div className="doctor-accent-num">BAMS</div>
              <div className="doctor-accent-label">Certified</div>
            </div>
          </div>
          <div className="fade-up">
            <p className="section-label">Meet Your Healer</p>
            <h2 className="section-title">
              Guided by <em>Expertise</em>,<br />Driven by Care
            </h2>
            <p className="doctor-credentials">
              BAMS, MD · Ayurvedic Physician · Panchakarma Specialist
            </p>
            <p className="doctor-bio">
              Our lead physician brings deep expertise in classical Ayurvedic medicine,
              with specialisation in Panchakarma therapies, skin disorders, metabolic
              conditions, and stress management. Every treatment plan at KayaSparsha is
              crafted with precision — honouring both ancient texts and your individual
              constitution.
            </p>
            <p className="doctor-bio">
              Consultations begin with Nadi Pariksha (pulse diagnosis) and Prakriti
              analysis — a 30-minute holistic assessment that forms the foundation of
              all care.
            </p>
            <div className="doctor-specialties">
              <span className="specialty-tag">Panchakarma</span>
              <span className="specialty-tag">Skin & Dermatology</span>
              <span className="specialty-tag">Stress & Burnout</span>
              <span className="specialty-tag">Women's Health</span>
              <span className="specialty-tag">Back & Joint Care</span>
              <span className="specialty-tag">Weight Management</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
